export default __webpack_public_path__ + "static/media/trainCoursePh.50f91f02.png";